import makeTrackEvent, { LAZY_LOAD_FAILURE_EVENT } from './makeTrackEvent'

export { LAZY_LOAD_FAILURE_EVENT }

export default makeTrackEvent
